import { getLocalizedValue } from '@grandvisionhq/utils';

const getProductTag = (variant, locale)=>{
    const zeroDiscount = getZeroDiscountValue(variant, locale);
    const tags = variant.tags;
    if (zeroDiscount) {
        return {
            key: null,
            value: zeroDiscount
        };
    }
    if (tags && tags[0]) {
        const value = typeof tags[0].value !== 'string' ? getLocalizedValue(tags[0].value, locale) : tags[0].value;
        return {
            key: tags[0].key,
            value
        };
    }
    return undefined;
};
// gets description value and to create a custom tag. remove this after the unification
const getZeroDiscountValue = (variant, locale)=>{
    var ref, ref1;
    if (!Array.isArray(variant.prices) || !variant.prices[0]) {
        return undefined;
    }
    const { discounted  } = variant.prices[0];
    // check that discounted contains discount object
    if (!discounted || !((ref = discounted.discount) === null || ref === void 0 ? void 0 : ref.obj)) return undefined;
    const { value , description  } = (ref1 = discounted.discount) === null || ref1 === void 0 ? void 0 : ref1.obj;
    let discountLabel = undefined;
    if (value.type === 'absolute') {
        var ref2;
        discountLabel = description && (value.money && ((ref2 = value.money[0]) === null || ref2 === void 0 ? void 0 : ref2.centAmount)) === 0 ? getLocalizedValue(description, locale) : undefined;
    } else if (value.type === 'relative') {
        discountLabel = description && value.permyriad === 0 ? getLocalizedValue(description, locale) : undefined;
    }
    return discountLabel;
};

export { getProductTag };
//# sourceMappingURL=get-product-tag.js.map
